import store from "@/redux/store";

import React, { useState } from "react";
import { useParams } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { show } from '@/reducers/Modal'
import { alert, info,success, error } from '@/reducers/Modal'
import { addTenant, tenantoverview, tenantEdit, newTenant} from '@/reducers/Tenant'
import {loadUsers, loadUser, saveUserData} from '@/reducers/AdminUser';
import { TenantModel } from "@/models/Tenant";
import { TenantOverview } from "@/views/Tenant/TenantOverview";
import { AdminUserOverview} from "@/views/admin/user/Overview";
import { AdminUserDetail} from "@/views/admin/user/Detail";

import {Detail} from "@/views/Tenant/Detail";
import {ADMINUSER} from "@/actions/globalConst";

class AdminUserController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
    this.onSaveHandler = this.onSaveHandler.bind(this);
  }


   componentDidMount() {
         if(this.props?.data.status == ADMINUSER.API_INIT && (location.pathname.search("/edit") != 0) ){
            store.dispatch( loadUsers() );
        }

        if(this.props?.selectedId && this.props?.selectedId != "" && (this.props.data.selected.key == "" || this.props?.selectedId != this.props.data.selected.key)) {
            store.dispatch( loadUser(this.props.selectedId));
        }

        if(this.props?.view == "add" ) {
            store.dispatch( newTenant());
        }
    
    let view = "";
        
   };

  
    onSaveHandler = async (selectedId, data) => {
        data.key = selectedId;
        const { dispatch } = this.props;


     try {
        await dispatch(saveUserData(data)).then((retData) => {
            if(!retData.error) {
                //this.props.navigate("/team/", {"replace": true});
            }
        })
        if(!this.props.error) {
            dispatch( alert({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
        }
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }
        if(!this.props.error) {
            dispatch( success({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
       } 

      
    }
  
  render() {
      const {tenant} = this.props;
      if(this.props?.data.status == ADMINUSER.API_READY) {
        if((this.props?.data?.view == ADMINUSER.VIEW_DETAIL) && (location.pathname.search("/edit") > 0 )) {  
      return (
          <AdminUserDetail {...this.props} key="adminUserDetail" data={this.props.data.selected} userfields={this.props.data.userfields} changekey={this.props.changeKey} onSaveHandler={this.onSaveHandler} />
      );
        }

    return (
      <AdminUserOverview {...this.props} users={this.props?.data?.users}  onSaveHandler={this.onSaveHandler}/>
    );

      }      
  }
}
const AdminUserControllerInit = (props) => {
    const { id } = useParams();
    const {selected} = props;

  return (
    <AdminUserController 
      {...props} selectedId={id} tenant={selected}
    />
  );
};

function mapStateToProps(state) {
    const {AuthReducer, UserReducer, TenantReducer, AdminUserReducer} = state;
    const {selected} = TenantReducer
    const {key} = UserReducer;
    const {user} = AuthReducer.user;
    const {error} = UserReducer;
    
  return {
    user: user,
    error: error,
    changeKey: key,
    selected: selected,
    data: {...AdminUserReducer}
  };
}

export default connect(mapStateToProps)(AdminUserControllerInit);  